import styled from 'styled-components';
import { Color } from '../../../../common/view/color/color';
import { FontSize } from '../../../../common/view/font/font-size';
import { CssFuncs } from '../../../../foundation/css/css.funcs';

const Container = styled.div.withConfig({
  componentId: 'mega-board-col_container',
  displayName: 'MegaBoardCol.Container',
})`
  width: 360px;

  border-radius: 10px;
  padding: 10px;

  &.is-not-placeholder,
  &.is-focused,
  &.is-placeholder:hover {
    background-color: ${Color.alpha.white1};
  }

  ${CssFuncs.css.asAbsoluteContainer()}
`;

const TitleContainer = styled.div.withConfig({
  componentId: 'mega-board-col_title-container',
  displayName: 'MegaBoardCol.TitleContainer',
})`
  ${CssFuncs.css.asAbsoluteContainer()}
`;

const TitleText = styled.div.withConfig({
  componentId: 'mega-board-col_title-text',
  displayName: 'MegaBoardCol.TitleText',
})`
  & div {
    font-size: ${FontSize.l4};
    font-weight: bold;
    color: ${Color.white2};
  }
`;

const Placeholder = styled.div.withConfig({
  componentId: 'mega-board-col_placeholder',
  displayName: 'MegaBoardCol.Placeholder',
})`
  ${CssFuncs.css.absolute({
    top: '0px',
    left: '0px',
  })}

  ${CssFuncs.css.padding({
    left: '5px',
  })}

  font-size: ${FontSize.l4};
  font-weight: bold;

  transition: color 0.1s linear;
  color: ${Color.alpha.white0};

  ${Container}.is-focused &, ${Container}:hover & {
    color: ${Color.alpha.white7};
  }

  ${CssFuncs.css.eventPassThrough()}
`;

const ActionButton = styled.div.withConfig({
  componentId: 'mega-board-col_action-button',
  displayName: 'MegaBoardCol.ActionButton',
})`
  transition: opacity 0.1s linear;
  opacity: 0;

  ${Container}:hover & {
    opacity: 1;
  }
`;

const Anchor = styled.div.withConfig({
  componentId: 'mega-board-col_anchor',
  displayName: 'MegaBoardCol.Anchor',
})`
  ${CssFuncs.css.absolute({
    top: '0px',
    left: '50%',
  })}

  ${CssFuncs.css.size({
    xy: '0px',
  })}
  ${CssFuncs.css.xCenterAlignInside()}
`;

const TopButton = styled.div.withConfig({
  componentId: 'mega-board-col_top-button',
  displayName: 'MegaBoardCol.TopButton',
})`
  ${CssFuncs.css.absolute({
    bottom: '0px',
    x: '0px',
  })}

  ${CssFuncs.css.padding({
    bottom: '4px',
  })}
  ${CssFuncs.css.xCenterAlignInside()}

  transition: opacity 0.1s linear;
  opacity: 0;

  ${Container}:hover & {
    opacity: 1;
  }
`;

export const MegaBoardColStyle = {
  Container,
  TitleContainer,
  TitleText,
  Placeholder,
  ActionButton,
  Anchor,
  TopButton,
};
